export var StreamRepresentation;
(function (StreamRepresentation) {
    StreamRepresentation["VIDEO"] = "VIDEO";
    StreamRepresentation["AUDIO"] = "AUDIO";
    StreamRepresentation["TEXT"] = "TEXT";
})(StreamRepresentation || (StreamRepresentation = {}));
